<template>
    <div
        v-if="!isCostablePageLoading"
        v-show="selectedCostCount > 0"
        class="v-fade"
    >
        <b-dropdown
            class="with-selected__dropdown mb-4"
            variant="primary"
            :disabled="disabled"
        >

            <template slot="button-content">
                <span class="mr-1">{{ dropdownText }}</span>
                <i class="fa fa-fw fa-caret-down" />
            </template>

            <b-dropdown-header>Selected costs actions</b-dropdown-header>

            <b-dropdown-item @click="addToGroup">
                <i class="fa fa-fw fa-arrow-right" />
                <span class="ml-2">Add to group</span>
            </b-dropdown-item>

            <b-dropdown-item
                v-show="canAddToTab"
                @click="addToTab"
            >
                <i class="fa fa-fw fa-arrow-right" />
                <span class="ml-2">Add to tab</span>
            </b-dropdown-item>

            <b-dropdown-item @click="changeMultiple">
                <i class="fa fa-fw fa-pencil" />
                <span class="ml-2">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="changeCost">
                <i class="fa fa-fw fa-pencil" />
                <span class="ml-2">Change cost</span>
            </b-dropdown-item>

            <b-dropdown-item @click="changePrice">
                <i class="fa fa-fw fa-pencil" />
                <span class="ml-2">Change price</span>
            </b-dropdown-item>

            <b-dropdown-item @click="unapproveCosts" v-if="canApproveCosts">
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Unapprove cost</span>
            </b-dropdown-item>

            <b-dropdown-item @click="approveCosts" v-if="canApproveCosts">
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Approve cost</span>
            </b-dropdown-item>

            <b-dropdown-item @click="reconcileCosts">
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Reconcile</span>
            </b-dropdown-item>

            <b-dropdown-item @click="unreconcileCosts">
                <i class="fa fa-fw fa-check" />
                <span class="ml-2">Unreconcile</span>
            </b-dropdown-item>

            <b-dropdown-item @click="deleteCosts">
                <i class="fa fa-fw fa-trash" />
                <span class="ml-2">Delete</span>
            </b-dropdown-item>

            <b-dropdown-item @click="saveAsQuote" v-if="this.$store.getters['costable/costableType'] == 'event'">
                <i class="fa fa-fw fa-save" />
                <span class="ml-2">Save as Quote</span>
            </b-dropdown-item>

        </b-dropdown>
    </div>
</template>

<script>
export default {

    computed: {
        isCostablePageLoading() {
            return this.$store.getters['costable/isCostablePageLoading'];
        },
        selectedCosts() {
            return this.$store.getters['costable/selectedCosts'];
        },
        selectedCostIds() {
            return this.$store.getters['costable/selectedCostIds'];
        },
        tableLoading() {
            return this.$store.getters['costable/isCostableTableLoading'];
        },
        selectedCostCount() {
            return this.selectedCostIds.length;
        },
        dropdownText() {
            return this.selectedCostCount <= 1 ? 'Act on selected Cost' : `Act on ${this.selectedCostCount} selected Costs`;
        },
        disabled() {
            return this.tableLoading;
        },
        areSelectedOnlyOtherCosts() {
            return !this.selectedCosts.some(cost => cost.group_id);
        },
        canAddToTab() {
            return this.areSelectedOnlyOtherCosts && this.$store.getters['costable/areTabsEnabled'];
        },
        canApproveCosts() {
            return this.$store.getters['costable/canApproveCosts'];
        },
    },

    methods: {
        changeMultiple() {
            this.$eventBus.$emit(this.$events.openChangeMultipleModal);
        },
        changeCommission() {
            this.$eventBus.$emit(this.$events.openChangeCommissionModal);
        },
        changeCost() {
            this.$eventBus.$emit(this.$events.openChangeUnitCostModal);
        },
        changePrice() {
            this.$eventBus.$emit(this.$events.openChangeUnitPriceModal);
        },
        changeDiscount() {
            this.$eventBus.$emit(this.$events.openChangeDiscountModal);
        },
        changeManagementFee() {
            this.$eventBus.$emit(this.$events.openChangeManagementFeeModal);
        },
        changeStatus() {
            this.$eventBus.$emit(this.$events.openChangeStatusModal);
        },
        changeUser() {
            this.$eventBus.$emit(this.$events.openChangeUserModal);
        },
        changeSupplier() {
            this.$eventBus.$emit(this.$events.openChangeSupplierModal);
        },
        changeQuantity() {
            this.$eventBus.$emit(this.$events.openChangeQuantityModal);
        },
        changeTaxRate() {
            this.$eventBus.$emit(this.$events.openChangeTaxRateModal);
        },
        deleteCosts() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Delete ${this.selectedCostCount} costs`,
                body: 'Are you sure you want to delete the selected costs?',
                submitButtonVariant: 'danger',
                onSubmit: () => {
                    this.$store.dispatch('costable/deleteCosts', this.selectedCostIds);
                },
            });
        },
        approveCosts() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Approve ${this.selectedCostCount} costs`,
                body: 'Are you sure you want to approve the selected costs?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/approveCosts', this.selectedCostIds);
                },
            });
        },
       unapproveCosts() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Approve ${this.selectedCostCount} costs`,
                body: 'Are you sure you want to unapprove the selected costs?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/unapproveCosts', this.selectedCostIds);
                },
            });
        },
        reconcileCosts() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Reconcile ${this.selectedCostCount} costs`,
                body: 'Are you sure you want to reconcile the selected costs?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/reconcileCosts', this.selectedCostIds);
                },
            });
        },
        unreconcileCosts() {
            this.$eventBus.$emit(this.$events.openConfirmationModal, {
                title: `Unreconcile ${this.selectedCostCount} costs`,
                body: 'Are you sure you want to unreconcile the selected costs?',
                submitButtonVariant: 'success',
                onSubmit: () => {
                    this.$store.dispatch('costable/unreconcileCosts', this.selectedCostIds);
                },
            });
        },
        addToTab() {
            this.$eventBus.$emit(this.$events.openAddToTabModal, {
                title: `Add ${this.selectedCostCount} costs to tab`,
                costIds: this.selectedCostIds,
            });
        },
        addToGroup() {
            this.$eventBus.$emit(this.$events.openAddToGroupModal, {
                title: `Add ${this.selectedCostCount} costs to group`,
                costIds: this.selectedCostIds,
            });
        },
        saveAsQuote() {
            this.$store.dispatch('costable/saveCostsAsQuote', this.selectedCostIds);
        },
    },

};
</script>

<style scoped>
.with-selected__dropdown {
    position: fixed;
    bottom: 0;
    z-index: 100;
}
</style>
